import BigNumber from 'bignumber.js'

export let MAX_DISCOUNT_PERCENTAGE_BASE = /** @type {const} */ ([
  {
    id: 'treatment_fee',
    text: 'Total treatment fee',
  },
  {
    id: 'payor_share',
    text: 'Payor’s share',
  },
])

export let MAX_DISCOUNT_TYPE = /** @type {const} */ ([
  {
    id: 'percentage',
    text: '% of either treatment fee or payor share',
  },
  {
    id: 'amount',
    text: 'Fixed amount',
  },
])

/**
 * Calculates max discount amount based on type and percentage base
 * @type {import('./case-closer-types.d.ts').getMaxDiscountAmount}
 */
export function getMaxDiscountAmount({
  max_discount,
  payor_share,
  treatment_fee,
}) {
  switch (max_discount?.type) {
    case 'percentage': {
      let base =
        max_discount.percentage_base === 'payor_share'
          ? payor_share
          : max_discount.percentage_base === 'treatment_fee'
            ? treatment_fee
            : null

      if (!base) return null

      return BigNumber(base)
        .multipliedBy(max_discount.value)
        .dividedBy(100)
        .decimalPlaces(2)
        .toNumber()
    }
    case 'amount': {
      return max_discount.value
    }
    default: {
      return null
    }
  }
}

/**
 * Adds discount amounts
 * @type {import('./case-closer-types.d.ts').getTotalDiscounts}
 */
export function getTotalDiscounts({ discounts }) {
  return discounts
    .reduce((acc, discount) => acc.plus(discount.amount), BigNumber(0))
    .decimalPlaces(2)
    .toNumber()
}

/**
 * Adds treatment discount amounts
 * @type {import('./case-closer-types.d.ts').getTotalTreatmentDiscounts}
 */
export function getTotalTreatmentDiscounts({ discounts }) {
  return getTotalDiscounts({
    discounts: discounts.filter(discount => !discount.is_applied_to_payor),
  })
}

/**
 * Adds payor discount amounts
 * @type {import('./case-closer-types.d.ts').getTotalPayorDiscounts}
 */
export function getTotalPayorDiscounts({ discounts }) {
  return getTotalDiscounts({
    discounts: discounts.filter(discount => discount.is_applied_to_payor),
  })
}
